/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SurgicalHistory from './surgical-history';
import SurgicalHistoryDetail from './surgical-history-detail';
import SurgicalHistoryUpdate from './surgical-history-update';
import SurgicalHistoryDeleteDialog from './surgical-history-delete-dialog';

const SurgicalHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SurgicalHistory />} />
    <Route path="new" element={<SurgicalHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<SurgicalHistoryDetail />} />
      <Route path="edit" element={<SurgicalHistoryUpdate />} />
      <Route path="delete" element={<SurgicalHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SurgicalHistoryRoutes;
